import { Instagram, MapPin, MessageCircle, Phone } from "lucide-react";
import { INSTAGRAM_URL, MAPS_LINK, PHONE_TEL, WA_NUMBER } from "../data/site";
import { trackEvent } from "../lib/track";

const waInfo = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("Merhaba Lunessa Spa Masaj, randevu hakkında bilgi almak istiyorum.")}`;

export default function SideRails() {
  return (
    <>
      <div className="side-rail left" data-testid="side-rail-left">
        <a
          href={`tel:${PHONE_TEL}`}
          onClick={() => trackEvent("phone_click", { location: "side_rail" })}
          aria-label="Telefonla ara"
          data-testid="rail-phone"
        >
          <Phone size={19} />
        </a>
        <a
          href={waInfo}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackEvent("whatsapp_click", { location: "side_rail" })}
          aria-label="WhatsApp ile yazın"
          data-testid="rail-whatsapp"
        >
          <MessageCircle size={19} />
        </a>
      </div>
      <div className="side-rail right" data-testid="side-rail-right">
        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="rail-instagram">
          <Instagram size={19} />
        </a>
        <a href={MAPS_LINK} target="_blank" rel="noreferrer" aria-label="Konum" data-testid="rail-location">
          <MapPin size={19} />
        </a>
      </div>
    </>
  );
}
